import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Button, Divider } from 'antd';
import {
  FileTextOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import {
  CustomButton,
  CustomTable,
  CustomTabs,
  CustomText,
  CustomTextArea,
} from '../../../../components';
import GestorTableItems from '../components/GestorTableItems';

interface GoodsDetailViewProps {
  detailData?: any;
  setFooterLeft: (footer: React.ReactNode) => void;
  onDocuments: (petition_id: number) => void;
  onDownloadPDf: (petition_id: number) => void;
  isPendingFiles: boolean;
  isPendingPdf: boolean;
  isEnTramiteEntrega?: boolean;
  formikEntrega?: any;
}

const DirectGoodsDetailView: React.FC<GoodsDetailViewProps> = ({
  detailData,
  setFooterLeft,
  onDocuments,
  onDownloadPDf,
  isPendingFiles,
  isPendingPdf,
  isEnTramiteEntrega,
  formikEntrega,
}) => {
  const [columTableBienes, setColumTableBienes] = useState<any>([]);

  // FOOTER
  React.useEffect(() => {
    setFooterLeft(
      <>
        <CustomButton
          label="Descargar documentos"
          disabled={
            !detailData?.documents ||
            detailData.documents.length === 0 ||
            isPendingFiles
          }
          onClick={() => {
            onDocuments(Number(detailData?.id));
          }}
          icon={<DownloadOutlined />}
          size="middle"
          buttonType="secondary"
        />

        <CustomButton
          style={{ marginLeft: '20px' }}
          label="Generar comprobante"
          disabled={
            isPendingPdf || [10, 11, 28].includes(detailData?.status_id)
          }
          onClick={() => {
            onDownloadPDf(Number(detailData?.id));
          }}
          icon={<DownloadOutlined />}
          size="middle"
          buttonType="secondary"
        />
      </>
    );
  }, [
    detailData,
    setFooterLeft,
    isPendingFiles,
    isPendingPdf,
    onDocuments,
    onDownloadPDf,
  ]);

  useEffect(() => {
    setColumTableBienes([
      {
        title: 'Item',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: 'Código de producto',
        dataIndex: 'product_code',
        key: 'product_code',
        align: 'center',
        render: (data: any) => (data ? data : '-'),
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
        align: 'center',
        render: (data: any) => (data ? data : '-'),
      },
      {
        title: 'Grupo de bienes',
        dataIndex: 'good_class',
        key: 'good_class',
        align: 'center',
        render: (_: any, record: any) => {
          return record.good_class_id && record.good_class
            ? `${record.good_class_id} - ${record.good_class}`
            : '-';
        },
      },
      {
        title: 'Unidad de medida',
        dataIndex: 'unit_measurement',
        key: 'unit_measurement',
        align: 'center',
        render: (data: any) => (data ? data : '-'),
      },
      {
        title: 'Cantidad entregada',
        dataIndex: 'quantity',
        key: 'quantity',
        align: 'center',
        render: (data: any) => (data ? data : '-'),
      },
    ]);
  }, [detailData]);
  const documentColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <Fragment>
      {isEnTramiteEntrega && (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <CustomTextArea
              label="Observaciones"
              name="observations"
              placeholder="Ingrese observaciones..."
              maxLength={300}
              value={formikEntrega.values.observations}
              onChange={formikEntrega.handleChange}
              onBlur={formikEntrega.handleBlur}
              error={formikEntrega.errors.observations}
              touched={formikEntrega.touched.observations}
            />
          </Col>
        </Row>
      )}

      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <span>
                <FileTextOutlined /> Información general
              </span>
            ),
            children: (
              <>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Solicitante:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.requester}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Fecha de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.transaction_date}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Ubicación:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.location}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Tipo de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.request_type}
                        fontSize="middle"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Estado de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.status} fontSize="middle" />
                    </div>
                  </Col>
                </Row>

                <GestorTableItems
                  detailData={detailData}
                  columnsBienes={columTableBienes}
                />
              </>
            ),
          },
          {
            key: '2',
            label: (
              <span>
                <FileSearchOutlined /> Documentos
              </span>
            ),
            children: (
              <>
                <CustomTable
                  dataSource={detailData?.documents?.map(
                    (doc: any, index: number) => ({
                      key: index,
                      createdAt: doc.created_at,
                      name: doc.url?.split('/').pop(),
                      link: doc.url,
                    })
                  )}
                  columns={documentColumns}
                  pagination={false}
                />
              </>
            ),
          },
          {
            key: '3',
            label: (
              <span>
                <HistoryOutlined /> Historial de la solicitud
              </span>
            ),
            children: (
              <CustomTable
                columns={[
                  {
                    title: 'Item',
                    dataIndex: 'index',
                    key: 'index',
                    render: (_: any, __: any, index: number) => index + 1,
                  },
                  {
                    title: 'Fecha',
                    dataIndex: 'date',
                    key: 'date',
                  },
                  {
                    title: 'Usuario',
                    dataIndex: 'user',
                    key: 'user',
                    render: (_: any, record: any) =>
                      record.document + ' - ' + record.user,
                  },
                  {
                    title: 'Observaciones',
                    dataIndex: 'observations',
                    key: 'observations',
                  },
                  {
                    title: 'Estado',
                    dataIndex: 'comment',
                    key: 'comment',
                    render: (text: string) => {
                      if (!text) return '';
                      return (
                        text.charAt(0).toUpperCase() +
                        text.slice(1).toLowerCase()
                      );
                    },
                  },
                ]}
                dataSource={
                  detailData?.history?.map((item: any, index: number) => ({
                    key: index,
                    date: item.date,
                    comment: item.comment,
                    user: item.user,
                    document: item.user_document,
                    observations: item.observations,
                  })) || []
                }
                pagination={false}
              />
            ),
          },
        ]}
      />
      <Divider />
    </Fragment>
  );
};

export default DirectGoodsDetailView;
